import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class GenericDocumentQueryCriteriaClass extends BaseCriteriaModel {
  //for the header(s)
  doc_source_type?: Optional<string> = Optional.empty();
  server_doc_type?: Optional<string> = Optional.empty();
  client_doc_type?: Optional<string> = Optional.empty();
  guid_comp?: Optional<string> = Optional.empty();
  guid_branch?: Optional<string> = Optional.empty();
  guid_store?: Optional<string> = Optional.empty();
  client_guid?: Optional<string> = Optional.empty();
  client_doc_1?: Optional<string> = Optional.empty();
  doc_desc?: Optional<string> = Optional.empty();
  doc_entity_hdr_guid?: Optional<string> = Optional.empty();
  guids?: Optional<string> = Optional.empty();  /** @param guids is comma separated E.g: 4BC80017-22CC-4A29-9511-E22C4EB97AD5,4BC80017-22CC-4A29-9511-E22C4EB97AD5*/


  //for the extension(s)
  ext_type?: Optional<string> = Optional.empty();
  ext_code?: Optional<string> = Optional.empty();
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
  value_numeric?: Optional<number> = Optional.empty();;

  //for the line(s)
  line_code?: Optional<string> = Optional.empty();
  line_name?: Optional<string> = Optional.empty();
  line_hdr_guid?: Optional<string> = Optional.empty();

  //for the link(s)
  link_code?: Optional<string> = Optional.empty();
  link_name?: Optional<string> = Optional.empty();
  link_hdr_guid?: Optional<string> = Optional.empty();

  //for the event(s)
  event_code?: Optional<string> = Optional.empty();
  event_name?: Optional<string> = Optional.empty();
  event_hdr_guid?: Optional<string> = Optional.empty();
  txn_type?: Optional<string> = Optional.empty();
  event_doc_line?: Optional<string> = Optional.empty();
  action?: Optional<string> = Optional.empty();

}

export class GenericDocumentCriteriaModelQuery {
  query = '';

  constructor(GenericDocumentCriteriaModel: GenericDocumentQueryCriteriaClass) {

    if (!GenericDocumentCriteriaModel) {
      return;
    }

    this.query += GenericDocumentCriteriaModel.doc_source_type.filter(x => x !== '').map(x => '&doc_source_type=' + x).orElse('');
    this.query += GenericDocumentCriteriaModel.server_doc_type.filter(x => x !== '').map(x => '&server_doc_type=' + x).orElse('');
    this.query += GenericDocumentCriteriaModel.client_doc_type.filter(x => x !== '').map(x => '&client_doc_type=' + x).orElse('');
    this.query += GenericDocumentCriteriaModel.guid_comp.filter(x => x !== '').map(x => '&guid_comp=' + x).orElse('');
    this.query += GenericDocumentCriteriaModel.guid_branch.filter(x => x !== '').map(x => '&guid_branch=' + x).orElse('');
    this.query += GenericDocumentCriteriaModel.guid_store.filter(x => x !== '').map(x => '&guid_store=' + x).orElse('');
    this.query += GenericDocumentCriteriaModel.client_guid.filter(x => x !== '').map(x => '&client_guid=' + x).orElse('');
    this.query += GenericDocumentCriteriaModel.client_doc_1.filter(x => x !== '').map(x => '&client_doc_1=' + x).orElse('');
    this.query += GenericDocumentCriteriaModel.doc_desc.filter(x => x !== '').map(x => '&doc_desc=' + x).orElse('');
    this.query += GenericDocumentCriteriaModel.doc_entity_hdr_guid.filter(x => x !== '').map(x => '&doc_entity_hdr_guid=' + x).orElse('');
    this.query += GenericDocumentCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');

    this.query += GenericDocumentCriteriaModel.ext_type.filter(x => x !== '').map(x => '&ext_type=' + x).orElse('');
    this.query += GenericDocumentCriteriaModel.ext_code.filter(x => x !== '').map(x => '&ext_code=' + x).orElse('');
    this.query += GenericDocumentCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += GenericDocumentCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += GenericDocumentCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += GenericDocumentCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += GenericDocumentCriteriaModel.value_numeric.filter(x => x !== null).map(x => '&value_numeric=' + x).orElse('');

    this.query += GenericDocumentCriteriaModel.line_code.filter(x => x !== '').map(x => '&line_code=' + x).orElse('');
    this.query += GenericDocumentCriteriaModel.line_name.filter(x => x !== '').map(x => '&line_name=' + x).orElse('');
    this.query += GenericDocumentCriteriaModel.line_hdr_guid.filter(x => x !== '').map(x => '&line_hdr_guid=' + x).orElse('');
    this.query += GenericDocumentCriteriaModel.link_code.filter(x => x !== '').map(x => '&link_code=' + x).orElse('');
    this.query += GenericDocumentCriteriaModel.link_name.filter(x => x !== '').map(x => '&link_name=' + x).orElse('');
    this.query += GenericDocumentCriteriaModel.link_hdr_guid.filter(x => x !== '').map(x => '&link_hdr_guid=' + x).orElse('');

    this.query += GenericDocumentCriteriaModel.event_code.filter(x => x !== '').map(x => '&event_code=' + x).orElse('');
    this.query += GenericDocumentCriteriaModel.event_name.filter(x => x !== '').map(x => '&event_name=' + x).orElse('');
    this.query += GenericDocumentCriteriaModel.event_hdr_guid.filter(x => x !== '').map(x => '&event_hdr_guid=' + x).orElse('');
    this.query += GenericDocumentCriteriaModel.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');
    this.query += GenericDocumentCriteriaModel.event_doc_line.filter(x => x !== '').map(x => '&event_doc_line=' + x).orElse('');
    this.query += GenericDocumentCriteriaModel.action.filter(x => x !== '').map(x => '&action=' + x).orElse('');

    this.query += '&status=' + GenericDocumentCriteriaModel.status;
    this.query += '&orderBy=' + GenericDocumentCriteriaModel.orderBy;
    this.query += '&order=' + GenericDocumentCriteriaModel.order;
    this.query += '&offset=' + GenericDocumentCriteriaModel.offset + '&limit=' + GenericDocumentCriteriaModel.limit;
  }
}
